import React from "react";

const ITEMS = [
  "Neubau",
  "Umbau",
  "Sanierung",
  "Schlüsselfertig",
  "Industriebau",
  "Stahlbetonbau",
  "Tiefbau",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="bg-zinc-950 border-y border-zinc-800 overflow-hidden"
    >
      <div className="py-6">
        <div className="flex animate-marquee whitespace-nowrap">
          {row.map((it, i) => (
            <div
              key={i}
              className="flex items-center gap-8 px-8 text-2xl md:text-3xl font-display font-black uppercase tracking-tighter"
            >
              <span className="text-white">{it}</span>
              <span className="text-red-600">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
